import i18next from 'i18next'
import { CSSProperties } from 'react'
import { ClosedParcel } from './AiThinkingParcel'

/*
The route-draw thinking indicator: a delivery route draws itself between pulsing stops,
fades, and redraws along a different path, from the Glow Intelligence design exploration.
The color rides on currentColor, reduced motion shows the closed parcel instead.
*/

const FIRST_ROUTE = 'M9 35L20 13L30 33L39 12'
const SECOND_ROUTE = 'M9 35L30 33L20 13L39 12'

const STOPS: Array<{ cx: number; cy: number; delay: string }> = [
  { cx: 9, cy: 35, delay: '0s' },
  // Staggered fractions of the 2.4s loop, so the stops pulse as a wave
  { cx: 20, cy: 13, delay: '-0.53s' },
  { cx: 30, cy: 33, delay: '-1.06s' },
  { cx: 39, cy: 12, delay: '-1.58s' }
]

const stopOrigin: CSSProperties = { transformBox: 'fill-box', transformOrigin: '50% 50%' }

// The head dot rides the route line while it draws
const headStyle = (route: string): CSSProperties => ({
  transformBox: 'view-box',
  offsetPath: `path('${route}')`,
  offsetRotate: '0deg'
})

const routeClass = 'fill-none stroke-current [stroke-dasharray:100] [stroke-width:3.2]'

export const AiThinkingRoute = ({ size = 32 }: { size?: number }) => (
  <span className="py-1 text-primary-500">
    <svg
      viewBox="0 0 48 48"
      width={size}
      height={size}
      role="img"
      aria-label={i18next.t('aiChat.thinking')}
      className="block"
    >
      <g className="motion-reduce:hidden">
        {STOPS.map((stop) => (
          <circle
            key={stop.delay}
            cx={stop.cx}
            cy={stop.cy}
            r={3.4}
            className="animate-route-stop fill-gray-300"
            style={{ ...stopOrigin, animationDelay: stop.delay }}
          />
        ))}
        <path
          d={FIRST_ROUTE}
          pathLength={100}
          strokeLinecap="round"
          strokeLinejoin="round"
          className={`animate-route-draw-first ${routeClass}`}
        />
        <path
          d={SECOND_ROUTE}
          pathLength={100}
          strokeLinecap="round"
          strokeLinejoin="round"
          className={`animate-route-draw-second ${routeClass}`}
        />
        <circle r={2.6} className="animate-route-head-first fill-current" style={headStyle(FIRST_ROUTE)} />
        <circle r={2.6} className="animate-route-head-second fill-current" style={headStyle(SECOND_ROUTE)} />
      </g>
      <g className="hidden motion-reduce:block">
        <ClosedParcel />
      </g>
    </svg>
  </span>
)
